import {Conversation} from '../models/Conversation';
import {ReadStatus} from '../enums/read-status';

export function conversationHasUnreadMessages(conversation: Conversation): boolean {
  return (conversation.readStatus === ReadStatus.UNSET && conversation.newMessage > 0) ||
    conversation.readStatus === ReadStatus.UNREAD;
}
